$('#contact-form').validate({
	rules: {
	  name: {
		required: true,
	  },
  
	  email: {
		email: true,
		required: true,
	  },
  
	  document: {
		required: true,
		minlength: (field) => {
			const length = field.value.length
			return length <= 14 ? 14 : 18
		}
	  },
  
	  body: {
		required: true,
	  },
  
	},
	messages: {
	  name: {
		required: "Adicione o seu nome antes de enviar."
	  },
  
	  email: {
		email: 'Digite um email válido.',
		required: "Adicione o seu email antes de enviar."
	  },
  
	  document: {
		required: "Adicione o seu CPF/CNPJ antes de enviar.",
		minlength: "Adicione um CPF/CNPJ valido.",
	  },
	  
	  body: {
		required: "Adicione sua menssagem antes de enviar."
	  },
	}
  })